import { GetCities } from './api/GetCities.js';

// получаем расписания
import { GetSchedule } from './api/GetSchedule.js'

// получаем даты прилётов
import { GetDates } from './GetDates.js';

export const GetDeparture = async (cityCode) => {

    let cities = await GetCities(cityCode);
    cities = cities.destination;

    // получаем коды городов
    let codeCities = cities.map(elem => elem.codeEn);
    // массив расписаний из разных направлений
    let schedules = [];

    // ?<--------------------------------------------------------------------------------------------------------------->

    for (const code of codeCities) {
        /*
         * получаем расписания
         * departure - откуда 
         * arrival - куда 
         */
        let schedule = await GetSchedule({ departure: cityCode, arrival: code });
        // заполняем массив расписаний
        if (schedule.scheduleFlights.length > 0) schedules.push(schedule.scheduleFlights);
    }

    // ?<--------------------------------------------------------------------------------------------------------------->

    // проходимся по всем направлениям
    for (const item of schedules) {
        // в направлениях проходимся по расписаниям
        for (const item2 of item) {
            // в направлениях проходимся по рейсам и возвращаем только те поля рейсов котоыре нам понадобятся
            item2.flights = item2.flights.map(elem => {
                return {
                    // дата начала активности рейса 
                    begin_date: elem.begin_date,
                    // дата окончания активности
                    end_date: elem.end_date,
                    // название города назначения
                    destinationcityName: elem.destinationcityName,
                    // код города названчения
                    destinationcity: elem.destinationcity,
                    // название города вылета
                    origincityName: elem.origincityName,
                    // код города вылета
                    origincity: elem.origincity,
                    // дни недели рейсов
                    weekday: elem.days,
                    // време вылета
                    departuretime: elem.departuretime,
                    // време прилёта
                    arrivaltime: elem.arrivaltime,
                    // время полёта
                    flightTime: elem.flightTime,
                    // номер рейса
                    racenumber: elem.racenumber,
                }
            });
        }
    }

    // ?<--------------------------------------------------------------------------------------------------------------->

    // расчитываем даты прилётов 
    schedules = GetDates(schedules);

    // ?<--------------------------------------------------------------------------------------------------------------->

    return schedules;
}